import React, { useEffect, useState } from 'react';
import { Card, Result, Spin } from 'antd';
import { useSearchParams, Link } from 'react-router-dom';
import { verifyEmail } from './authApi';

export default function VerifyEmailPage() {
  const [status, setStatus] = useState('verifying'); // verifying, success, error
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      return;
    }
    verifyEmail(token)
      .then(() => setStatus('success'))
      .catch(() => setStatus('error'));
  }, [token]);

  return (
    <div style={{ maxWidth: 500, margin: '80px auto', padding: '0 16px' }}>
      <Card style={{ borderRadius: 12 }}>
        {status === 'verifying' && (
          <div style={{ textAlign: 'center', padding: 40 }}>
            <Spin size="large" />
            <p style={{ marginTop: 16, color: '#666' }}>Verifying your email...</p>
          </div>
        )}
        {status === 'success' && (
          <Result
            status="success"
            title="Email verified!"
            subTitle="Your email has been confirmed. You can now post deals and comment."
            extra={<Link to="/">Go to homepage</Link>}
          />
        )}
        {status === 'error' && (
          <Result
            status="error"
            title="Verification failed"
            subTitle="The verification link is invalid or expired."
            extra={<Link to="/login">Back to sign in</Link>}
          />
        )}
      </Card>
    </div>
  );
}
